import { addBreadcrumb, captureSentryException } from "@utils/sentry";
import {
  getCapturedErrorMessage,
  normalizeCapturedError,
} from "@utils/normalizeCapturedError";

type CaptureChannel = "error" | "warning" | "breadcrumb" | "ignore";

type CaptureExceptionOptions = {
  channel: CaptureChannel;
  area: string;
  operation: string;
  fingerprint?: string[];
  tags?: Record<string, string>;
  extra?: Record<string, unknown>;
};

export const captureException = (
  error: unknown,
  options: CaptureExceptionOptions,
) => {
  if (options.channel === "breadcrumb" || options.channel === "warning") {
    addBreadcrumb({
      category: options.area,
      message: `${options.operation}: ${getCapturedErrorMessage(error)}`,
      level: options.channel === "warning" ? "warning" : "info",
      data: {
        ...options.extra,
        tags: options.tags,
      },
    });
    return;
  }

  if (options.channel === "ignore") {
    return;
  }

  const normalizedError = normalizeCapturedError(error, {
    area: options.area,
    operation: options.operation,
  });

  captureSentryException(normalizedError.error, {
    fingerprint: options.fingerprint,
    tags: {
      area: options.area,
      operation: options.operation,
      ...options.tags,
    },
    extra: {
      ...normalizedError.extra,
      ...options.extra,
    },
  });
};
